import React from 'react';

interface ISingleStatMetricProps {
  label: React.ReactNode | string;
  value: string | number;
}

const SingleStatMetric = ({ label, value }: ISingleStatMetricProps) => {
  return (
    <div>
      <p className="text-light text-xs md:text-sm font-medium">{label}</p>
      <p className="text-lighter text-xl md:text-2xl font-bold mt-2">{value}</p>
    </div>
  );
};

export default SingleStatMetric;
